<template>
  <div class="searchbar">
    <div>
      <ul>
        <li>
            <form class="m-t-10" role="form">
                <label>Agence</label>
                <div class="form-group filter">
                    <slot name="agencies"></slot>
                </div>
                <!-- <label>Agence</label>
                <div class="form-group form-group-default form-group-default-select2 selection-class">
                <slot name="agencies"></slot>
                </div> -->
            </form>
        </li>
        <li>
            <form class="m-t-10" role="form">
                <label>Période</label>
                <div class="form-group">
                    <slot name="bookings"></slot>
                </div>
            </form>
        </li>
        <li>
            <form class="m-t-10" role="form">
                <label>Annulées</label>
                <div class="form-group">
                    <slot name="canceled"></slot>
                </div>
            </form>
        </li>
        <!-- <li>
          <form class="m-t-10" role="form">
            <label>Période</label>
            <div class="form-group form-group-default form-group-default-select2 selection-class">
              <slot name="bookings"></slot>
            </div>
          </form>
        </li> -->
        <!-- <li>
          <form class="m-t-10" role="form">
            <label>Annulées</label>
            <div class="form-group form-group-default form-group-default-select2 selection-class">
              <slot name="canceled"></slot>
            </div>
          </form>
        </li> -->
      </ul>
    </div>
    <!-- <button class="btn btn-complete btn-cons">Ajouter une location</button> -->
  </div>
</template>

<style lang="scss" scoped>
  .searchbar {
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    // white-space: nowrap;
    padding-top: 10px;
    div {
    //   display: flex;
    //   flex-wrap: wrap;
      ul {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        li {
          display: inline-block;
          list-style-type: none;
          margin-right: 5px;
        }
      }
    }
    button {
      min-width: 150px;
    }
  }
  .selection-class {
    min-width: 160px;

  }
</style>

<script type="text/babel">
export default {
  name: "SearchBar",
  mounted () {
    $('.dropdown-multiselect').select2()
    $('.dropdown-select').select2({
      minimumResultsForSearch: -1
    })
  }
}
</script>



// WEBPACK FOOTER //
// client/components/OneTimeLocations/SearchBar.vue